/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingSessionDto } from '../../models/charging-session-dto';

export interface ApiOcppOperationSetMacAddressAndCarManufacturerPost$Params {
  chargerId?: string;
  transactionId?: number;
      body?: ChargingSessionDto
}

export function apiOcppOperationSetMacAddressAndCarManufacturerPost(http: HttpClient, rootUrl: string, params?: ApiOcppOperationSetMacAddressAndCarManufacturerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiOcppOperationSetMacAddressAndCarManufacturerPost.PATH, 'post');
  if (params) {
    rb.query('chargerId', params.chargerId, {});
    rb.query('transactionId', params.transactionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiOcppOperationSetMacAddressAndCarManufacturerPost.PATH = '/api/OcppOperation/SetMacAddressAndCarManufacturer';
